import { defineMessages } from 'react-intl';

export const ScopeName = 'Pages.ParticipantPage';

const Scope = defineMessages({
  title: {
    id: `${ScopeName}.title`,
    defaultMessage: 'Participante',
  },
  content: {
    id: `${ScopeName}.content`,
    defaultMessage: 'Conteúdo de exemplo <strong>Participante</strong>',
  },
});

export default Scope;
